import {useEffect, useState} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {ad_user_usuario} from "../../Servicios/Auth/Adaptadores/ad_user_usuario";
import {crearHash} from "../Funciones/crearHash";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {reducirHash} from "../Funciones/reducirHash";
import {empadrinarCuenta} from "./empadrinarCuenta";
import {crearEquipoPrimeraVez} from "../Equipos/crearEquipoPrimeraVez";


export const useEscucharUsuarioToCorreoBitNova = ({correo = null, funcionNoExiste = null, user, codigo, hash}) => {
    const [usuario, setUsuario] = useState(null)
    const [verificando, setVerificando] = useState(false)


    const verificarCuenta = async (id) => {
        let doxCuenta = await obtenerDoc('cuentas', id)


        if (doxCuenta.res && doxCuenta.data) {

            if (doxCuenta.data.estado === 'Aceptado') {
                return doxCuenta.data
            } else {
                alert('Tu cuenta ha sido suspendida por favor comunicate con soporte')
                return null
            }

        } else {

            //doble verificacion de cuenta mediante busqueda en equipos

            let doxEquipo = await obtenerDoc('equipos', id)
            if (doxEquipo.res && doxEquipo.data) {

                alert('Error al ingresar a tu cuenta, porfavor intenta nuevamente o comunicate con soporte')

            } else {
                console.log('crearCuenta')
                let usu = await crearCuenta(id)
                setUsuario(usu)
            }


        }

    }

    const crearCuenta = async (id) => {
        let cuenta = ad_user_usuario({user: user, usuario: {}})
        cuenta.id = id
        cuenta.estado = 'Aceptado'
        cuenta.tipo = 'Explorador'
        cuenta.codigo = crearHash({text: cuenta.correo})
        cuenta.minHash = reducirHash({hash: crearHash({text: cuenta.correo})})


        let w = [where('minHash', '==', codigo)]
        let dox = await obtenerColWheres({col: 'cuentas', wheres: w})
        if (dox.res && dox.data[0]) {
            cuenta.codigoPadre = dox.data[0].codigo
        } else {
            cuenta.codigoPadre = 'N/A'
        }


        let arrPadres = await empadrinarCuenta({cuenta: cuenta})
        cuenta.padres = arrPadres

        await crearEquipoPrimeraVez({idUsuario: cuenta.id})

        let doxCrear = await guardarDoc('cuentas', cuenta)
        if (doxCrear.res) {
            return cuenta
        } else {
            alert('Ocurrio un error, porfavor intentalo mas tarde')
            return null
        }
    }

    useEffect(() => {

        if (correo !== null) {
            setVerificando(true)
            let id = getID(correo);

            if (id) {
                verificarCuenta(id).then((dox) => {
                    if (dox) {
                        setUsuario(dox)
                    }
                    setVerificando(false)
                })
            }


        } else {
            setUsuario(null)
            setVerificando(false)
        }


    }, [correo])

    return {
        usuario,
        setUsuario,
        verificando
    }

}


export const getID = (email) => {

    try {
        let em = email.replaceAll("@", "_");
        return em.replaceAll(".", "-").toLowerCase();
    } catch (error) {

        let text = ''
        for (let i = 0; i < email.length; i++) {
            if (email[i] === '@') {
                text += '_'
            } else if (email[i] === '.') {
                text += '-'
            } else {
                text += email[i]
            }


        }

        let obj = {
            fecha: new Date().getTime(),
            error: JSON.stringify(error),
            email: email,
        }

        guardarDoc('errores', obj).then()

        return text;
    }


}